import React, { Component } from 'react';
import DataTable from 'react-data-table-component';
import Select from 'react-select';
import { Card, BreadCrumb, Confirm, Modal } from '../../components';
import { Translate } from '../../contexts/Language';
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Config } from '../../config';
import { ErrorMessage, Validator, VRules, VConditions } from '../../components/Validator';


export class BlackList extends Component {
  constructor(props) {
    super(props);

    this.Refs = React.createRef();

    this.state = {
      dataTable: {
        columns: DataTableColumns.transferOptionsBlackList,
        rows: [],
      },
      formData: {
        transferOption: '',
        login: '',
        transferType: '',
      },
      validation: {
        error: false,
        message: '',
      },
    };

    this.onDelete = this.onDelete.bind(this);
    this.onEdit = this.onEdit.bind(this);

    this.typeOptions = [
      { value: 'W', label: 'Withdrawal' },
      { value: 'D', label: 'Deposit' },
      { value: 'B', label: 'Both' },
    ];

    this.transferOptions = [];
  }

  componentDidMount() {
    this.onDataTable(true);
  }

  onDataTable(option) {
    Config.utilities.loadingFetch();

    Service.TransferOptions.BlackList().then(response => {
      if (response) {
        const { dataTable } = this.state;

        dataTable.rows = response;

        this.setState({
          dataTable,
        });
      }

      if (option) {
        this.onTransferOptionList();
      }

      Config.utilities.loadingFetch();
    });
  }

  onTransferOptionList() {
    Config.utilities.loadingFetch();

    Service.TransferOptions.TransferOptionList().then(response => {
      if (response) {
        this.transferOptions = response.map(item => ({
          value: item.id,
          label: (
            <span>
              <img src={`/assets/psp-logo/${(item.logo || 'defaultlogo.svg')}`} alt="" width="20" className="mb-1 mr-2" />
              {item.title}
            </span>
          ),
        }));
      }

      Config.utilities.loadingFetch();
    });
  }

  onFormChange(value, key) {
    const { formData } = this.state;

    formData[key] = value;

    this.setState({
      formData,
    });
  }

  onDelete(id) {
    Confirm({
      title: 'Are you sure?',
      type: { warning: true },
      description: 'The item will be deleted.',
      onConfirm: () => {
        Config.utilities.loadingFetch();

        Service.TransferOptions.BlackListDelete(id).then(response => {
          Config.utilities.loadingFetch();

          if (response) {
            this.onDataTable();
          }
        });
      },
      onCancel: () => { },
    });
  }

  onEdit(id) {
    Config.utilities.loadingFetch();

    this.setState(
      {
        modal: true,
        validation: {
          error: false,
          message: '',
        },
      },
    );

    Service.TransferOptions.BlackListEdit(id).then(response => {
      if (response) {
        const { formData } = this.state;

        formData.id = response.id;
        formData.login = response.login;
        [formData.transferOption] = this.transferOptions.filter(item => item.value === response.transferOption);
        [formData.transferType] = this.typeOptions.filter(item => item.value === response.transferType);

        this.setState({
          formData,
        });
      }

      Config.utilities.loadingFetch();
    });
  }

  onNew(modal) {
    this.setState({
      formData: {
        id: -1,
        transferOption: '',
        login: '',
        transferType: '',
      },
      modal: !(modal === false),
      validation: {
        error: false,
        message: '',
      },
    });
  }

  onSave() {
    const { formData } = this.state;
    const data = { ...formData };

    data.transferOption = data.transferOption.value || '';
    data.transferType = data.transferType.value || '';

    if (this.isValid(data)) {
      Config.utilities.loadingFetch();

      Service.TransferOptions.BlackListSave(data).then(response => {
        if (response.error) {
          this.setState({
            validation: {
              error: response.error,
              message: response.message,
            },
          });
        } else {
          this.onNew(false);
          this.onDataTable();
        }

        Config.utilities.loadingFetch();
      });
    }
  }

  isValid(data) {
    VRules.transferType = {
      Invalid: value => VConditions.Required(value),
      Message: Translate('Please select Transfer Type!'),
    };

    VRules.transferOption = {
      Invalid: value => VConditions.Required(value),
      Message: Translate('Please select Transfer Option!'),
    };

    const error = Validator.Valid(data, this.Refs);

    this.setState({
      validation: error,
    });

    return !error.error;
  }

  render() {
    const { modal, validation, formData, dataTable } = this.state;
    return (
      <>
        <BreadCrumb Title={Translate('Black List')} Name={Translate('Black List')} />
        <Modal Title={Translate('Edit Black List')} Show={modal} onClose={() => this.setState({ modal: false })}>
          <div className="row mt-1 mb-1">
            <p className="text-muted mb-2 ml-1 col-md-12 font-12">Role Information</p>
            <div className="col-md-12">
              <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                <ErrorMessage Validation={validation} />
                <div className="form-group row ml-1 mr-1">
                  <label htmlFor="login" className="col-sm-4 col-form-label">Login</label>
                  <div className="col-sm-8">
                    <input className="form-control" type="number" id="login" name="login" value={formData.login} onChange={e => this.onFormChange(e.target.value, 'login')} />
                  </div>
                </div>
                <div className="form-group row ml-1 mr-1">
                  <label htmlFor="transferOption" className="col-sm-4 col-form-label">Transfer Option</label>
                  <div className="col-sm-8">
                    <Select
                      id="transferOption"
                      value={formData.transferOption}
                      onChange={option => this.onFormChange(option, 'transferOption')}
                      options={this.transferOptions}
                      isMulti={false}
                      name="transferOption"
                    />
                  </div>
                </div>
                <div className="form-group row ml-1 mr-1">
                  <label htmlFor="transferType" className="col-sm-4 col-form-label">Transfer Type</label>
                  <div className="col-sm-8">
                    <Select
                      id="transferType"
                      value={formData.transferType}
                      onChange={option => this.onFormChange(option, 'transferType')}
                      options={this.typeOptions}
                      isMulti={false}
                      name="transferType"
                    />
                  </div>
                </div>
                <div className="form-group row ml-1 mr-1">
                  <label htmlFor="save-form" className="col-sm-4 col-form-label" />
                  <div className="col-sm-8">
                    <button type="button" className="btn btn-info float-right" onClick={() => this.onSave()}>
                      <i className="far fa-save mr-2" />
                      <span>Save Form</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal>
        <Card Title="Payment Service Black List" Description="Customer panel payment systems user black list.">
          <div className="row">
            <div className="col-md-12">
              <button type="button" className="btn btn-info position-absolute add-new-button tabless" onClick={() => this.onNew()}>
                <i className="fas fa-plus mr-2" />
                <span>Add New Login</span>
              </button>
              {dataTable.rows.length === 0 ? (
                <div className="alert alert-light" role="alert">
                  <em>
                    <strong className="mr-2">No record!</strong>
                    {Translate('No records found for the filter.')}
                  </em>
                </div>
              ) :
                (
                  <DataTable
                    noHeader
                    columns={dataTable.columns(this.onDelete, this.onEdit)}
                    data={dataTable.rows}
                    defaultSortField="id"
                    defaultSortAsc={false}
                    pagination
                    highlightOnHover
                  />
                )}
            </div>
          </div>
        </Card>
      </>
    );
  }
}
